export default "__VITE_ASSET__e8930eb6__"